// reducers.js
import { FETCH_RULES_REQUEST, FETCH_RULES_SUCCESS, FETCH_RULES_FAILURE, GET_ALL_RULES, LOGOUT } from '../actions/gameRulesAction';
const initialState = {
  loading: false,
  allRules: [],
  error: null,
};

const rulesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RULES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RULES_SUCCESS:
      return {
        ...state,
        loading: false,
        allRules: action.payload,
      };
    case FETCH_RULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case GET_ALL_RULES:
      return {...state, allRules: action.payload || []}; 
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default rulesReducer;
